const navbars = document.querySelectorAll('.header');
let navbar = null;

navbars.forEach(header => {
    const bgColor = window.getComputedStyle(header).backgroundColor;
    if (bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
        navbar = header;
    }
});

const submenus = document.querySelectorAll('.submenu');

if (navbar && submenus) {
    const navbarBgColor = window.getComputedStyle(navbar).backgroundColor;
    const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-color').trim();

    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
      
    function rgbToHex(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }

    const rgbValues = navbarBgColor.match(/\d+/g).map(Number);
    if (rgbToHex(...rgbValues).toLowerCase() === secondaryColor.toLowerCase()) {
        submenus.forEach(submenu => {
            console.log(submenu);
            submenu.classList.add('submenu--different-background');
        });
    }
}